<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M2.67416 11.3887L18.3247 11.3887L10.7992 3.86829L11.668 3.00008L20.6742 12.0001L11.668 21.0001L10.7992 20.1319L18.3247 12.6115L2.67416 12.6115L2.67416 11.3887Z"
      :class="colorClass"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.668 21.3535L10.4456 20.1319L17.7209 12.8615L2.42416 12.8615L2.42416 11.1387L17.7209 11.1387L10.4456 3.86829L11.668 2.64665L21.0278 12.0001L11.668 21.3535ZM20.3205 12.0001L11.668 3.35351L11.1529 3.86829L18.9286 11.6387L2.92416 11.6387L2.92416 12.3615L18.9286 12.3615L11.1529 20.1319L11.668 20.6466L20.3205 12.0001Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
